export const isProd =
  import.meta.env.MODE === 'production' &&
  // our build pipeline also marks qa as prod, so we need to additionally check that the hostname isn't qa-airkey.capitalone.com
  location.hostname === 'airkey.capitalone.com';
